// Module
var code = "<strong>Custom STL Upload</strong> ";
// Exports
module.exports = code;